import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton, { toggleButtonClasses } from '@mui/material/ToggleButton';
import { styled } from '@mui/material/styles';

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)({
  width: '100%',
});

export const StyledToggleButton = styled(ToggleButton)({
  flex: '0 0 50%',
  fontSize: '15px',
  lineHeight: '26px',
  letterSpacing: '0.4px',
  height: '40px',

  [`&.${toggleButtonClasses.root}`]: {
    background: '#fff',
    color: '#4700d1',
    border: '1px solid #3c3e42',
    borderRadius: '22px',
    textTransform: 'none'
  },
  [`&.${toggleButtonClasses.selected}`]: {
    background: '#4700d1',
    color: 'white',
    '&:hover': {
      background: '#310096',
    },
  },
});
